import { getNewErrorsArray } from '../../../utils/formatters';
import { GeneralActionsNames } from '../general/general.actions';
import { DeliveriesActionsNames } from './deliveries.actions';
import { DeliveriesState, DeliveriesAction } from './type';

const initialState: DeliveriesState = {
  isLoading: false,
  error: null,
  deliveries: [],
};

const deliveriesReducer = (
  state: DeliveriesState = initialState,
  action: DeliveriesAction
): DeliveriesState => {
  switch (action.type) {
    case DeliveriesActionsNames.GET_DELIVERIES.START:
      return { ...state, isLoading: true, error: null, deliveries: [] };
    case DeliveriesActionsNames.GET_DELIVERIES.FULFILLED:
      return { ...state, isLoading: false, deliveries: action.payload };
    case DeliveriesActionsNames.GET_DELIVERIES.REJECTED:
      return { ...state, isLoading: false, error: action.payload };
    case GeneralActionsNames.CLEAR_ERRORS.FULFILLED:
      return {
        ...state,
        error: getNewErrorsArray(state.error, action.payload),
      };
  }
  return state;
};

export default deliveriesReducer;
